(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-back-to-school"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('back-to-school-bar')) {
    customElements.define(
      'back-to-school-bar',
      class BackToSchoolBar extends HTMLElement {
        connectedCallback() {
          this.timerEl = this.querySelector('[data-timer]');
          this.startCountdown();
          this.startRotation();
        }

        disconnectedCallback() {
          clearInterval(this.tick);
          clearInterval(this.rotatorTimer);
        }

        startCountdown() {
          const year = parseInt(this.getAttribute('data-year'), 10);
          const month = parseInt(this.getAttribute('data-month'), 10) - 1;
          const day = parseInt(this.getAttribute('data-day'), 10);
          const hour = parseInt(this.getAttribute('data-hour'), 10);
          let minute = parseInt(this.getAttribute('data-minute'), 10);
          if (isNaN(minute)) minute = 0;

          if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hour)) {
            if (this.timerEl) this.timerEl.style.display = 'none';
            return;
          }

          this.target = new Date(year, month, day, hour, minute);
          this.els = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]'),
          };

          this.update();
          this.tick = setInterval(() => this.update(), 1000);
        }

        update() {
          const left = this.target - new Date();

          if (left <= 0) {
            clearInterval(this.tick);
            if (this.timerEl) this.timerEl.style.display = 'none';
            return;
          }

          const days = Math.floor(left / 86400000);
          const hours = Math.floor((left % 86400000) / 3600000);
          const minutes = Math.floor((left % 3600000) / 60000);
          const seconds = Math.floor((left % 60000) / 1000);

          if (this.els.days) this.els.days.textContent = String(days).padStart(2, '0');
          if (this.els.hours) this.els.hours.textContent = String(hours).padStart(2, '0');
          if (this.els.minutes) this.els.minutes.textContent = String(minutes).padStart(2, '0');
          if (this.els.seconds) this.els.seconds.textContent = String(seconds).padStart(2, '0');
        }

        startRotation() {
          this.messages = Array.prototype.slice.call(this.querySelectorAll('.bts-msg'));
          if (this.messages.length < 2) return;

          let interval = parseInt(this.getAttribute('data-interval'), 10);
          if (isNaN(interval) || interval < 1) interval = 5;

          this.index = 0;
          this.rotatorTimer = setInterval(() => {
            this.messages[this.index].classList.remove('is-active');
            this.index = (this.index + 1) % this.messages.length;
            this.messages[this.index].classList.add('is-active');
          }, interval * 1000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaqMedia(root) {
      var panel = root.querySelector('[data-faq-media-panel]');
      if (!panel) return;
      var medias = Array.prototype.slice.call(panel.querySelectorAll('[data-media-key]'));
      var fallback = panel.querySelector('[data-faq-media-default]');
      if (!medias.length && !fallback) return;

      function show(key) {
        var found = false;
        medias.forEach(function (m) {
          var match = key != null && m.getAttribute('data-media-key') === key;
          m.hidden = !match;
          if (match) found = true;
        });
        if (fallback) fallback.hidden = found;
        panel.hidden = !found && !fallback;
      }

      function visibleTarget() {
        var targets = root.querySelectorAll('.faq-groups__content [data-object-target]');
        for (var i = 0; i < targets.length; i++) {
          if (window.getComputedStyle(targets[i]).display !== 'none') return targets[i];
        }
        return targets[0] || null;
      }

      function mediaByKey(key) {
        for (var i = 0; i < medias.length; i++) {
          if (medias[i].getAttribute('data-media-key') === key) return medias[i];
        }
        return null;
      }

      function firstMediaKeyForGroup(groupIndex) {
        var prefix = groupIndex + '-';
        for (var i = 0; i < medias.length; i++) {
          if (medias[i].getAttribute('data-media-key').indexOf(prefix) === 0) {
            return medias[i].getAttribute('data-media-key');
          }
        }
        return null;
      }

      function update() {
        var target = visibleTarget();
        if (!target) {
          show(null);
          return;
        }
        var open = target.querySelector('[data-collapsible-group].collapsible-is-open[data-media-key]');
        if (open) {
          var openKey = open.getAttribute('data-media-key');
          show(mediaByKey(openKey) ? openKey : null);
          return;
        }
        show(firstMediaKeyForGroup(target.getAttribute('data-object-target')));
      }

      root.addEventListener('click', function () {
        window.setTimeout(update, 0);
      });
      update();
    }

    function boot() {
      var roots = document.querySelectorAll('.faq-groups--featured');
      Array.prototype.forEach.call(roots, initFaqMedia);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const BAR_SELECTOR = '.shopify-section-group-header-group [data-announcement-bar]';
  const PROPERTY = '--announcement-bar-height';

  if (window.announcementBarOffsetReady) return;
  window.announcementBarOffsetReady = true;

  const publish = (value) => {
    document.documentElement.style.setProperty(PROPERTY, value);
  };

  const measure = () => {
    const bar = document.querySelector(BAR_SELECTOR);
    if (!bar) {
      publish('0px');
      return;
    }

    /*
     * A bar that is still in the flow scrolls away with the rest of the page
     * and never covers the header, so it contributes nothing.
     */
    const position = window.getComputedStyle(bar).position;
    if (position !== 'fixed' && position !== 'sticky') {
      publish('0px');
      return;
    }

    publish(`${Math.ceil(bar.offsetHeight)}px`);
  };

  /*
   * A timer rather than requestAnimationFrame: frames are throttled while the
   * tab is in the background, which would leave a stale offset behind until
   * the visitor interacts with the page.
   */
  let timer = null;
  const schedule = () => {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      timer = null;
      measure();
    }, 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);

  /*
   * The bars only go fixed while the body carries `header-sticky`, so the
   * measurement has to follow that class rather than scroll position. Only
   * the root element is written to, so this cannot retrigger itself.
   */
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opod-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const nav = document.querySelector('[data-opod-anchor-nav]');
    if (!nav) return;

    const links = Array.from(nav.querySelectorAll('[data-opod-anchor-link]'));
    if (!links.length) return;

    // Drop links whose target is not on this page, so no dead anchor is exposed.
    const live = [];
    links.forEach((link) => {
      const id = link.getAttribute('data-opod-anchor-link');
      const target = id ? document.getElementById(id) : null;
      if (!target) {
        const item = link.closest('li');
        if (item) {
          item.remove();
        } else {
          link.remove();
        }
        return;
      }
      live.push({ link, target });
    });

    if (!live.length) {
      nav.remove();
      return;
    }

    const scroller = nav.querySelector('.opod-anchor-nav__inner');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // The row overflows on mobile, so the active link can sit off-screen.
    // scrollTo on the scroller, not scrollIntoView, which would also move the page.
    const revealLink = (link) => {
      if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;
      const left = link.offsetLeft - (scroller.clientWidth - link.offsetWidth) / 2;
      scroller.scrollTo({
        left: Math.max(0, left),
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    };

    let activeId = null;

    const setActive = (id) => {
      if (id === activeId) return;
      activeId = id;

      live.forEach(({ link }) => {
        const isActive = link.getAttribute('data-opod-anchor-link') === id;
        if (isActive) {
          link.setAttribute('aria-current', 'true');
          revealLink(link);
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    // Section-local observer. The global one in global.js only toggles `animate`.
    const visible = new Map();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visible.set(entry.target.id, entry.intersectionRatio);
          } else {
            visible.delete(entry.target.id);
          }
        });

        let bestId = null;
        let bestRatio = 0;
        visible.forEach((ratio, id) => {
          if (ratio > bestRatio) {
            bestRatio = ratio;
            bestId = id;
          }
        });

        if (bestId) setActive(bestId);
      },
      {
        rootMargin: '-20% 0px -60% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }
    );

    live.forEach(({ target }) => observer.observe(target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opod-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-opod-sticky-bar]');
    if (!bar) return;

    const show = () => bar.classList.add('is-visible');

    // Pinned open in the editor so the merchant can see what they are editing.
    if (window.Shopify && window.Shopify.designMode) {
      show();
      return;
    }

    const anchorId = bar.getAttribute('data-reveal-after');
    const trigger = anchorId ? document.getElementById(anchorId) : null;

    // No trigger on the page: show it rather than strand the CTA off-screen.
    if (!trigger) {
      show();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    });

    observer.observe(trigger);
  })();

  } catch(e) { console.error(e); }
})();
})();
